/* assets/scroll-gallery.js */
(function () {
  function init(root) {
    if (root.__sgReady) return;
    root.__sgReady = true;

    var track = root.querySelector('[data-sg-track]');
    var thumb = root.querySelector('[data-sg-thumb]');
    var next = root.querySelector('[data-sg-next]');
    var prev = root.querySelector('[data-sg-prev]');
    if (!track) return;

    var slides = track.children;
    var raf = null;

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return track.clientWidth + gap;
    }

    function index() {
      return Math.round(track.scrollLeft / step());
    }

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }

    function update() {
      raf = null;
      var count = slides.length;
      var i = Math.max(0, Math.min(count - 1, index()));

      if (thumb) {
        var w = 100 / count;
        var max = Math.max(1, track.scrollWidth - track.clientWidth);
        var p = Math.max(0, Math.min(1, track.scrollLeft / max));
        thumb.style.width = w + '%';
        thumb.style.transform = 'translateX(' + (p * (count - 1) * 100) + '%)';
      }
      if (prev) prev.hidden = i <= 0;
      if (next) next.hidden = i >= count - 1;
    }

    function queue() { if (!raf) raf = requestAnimationFrame(update); }

    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index() - 1); }
    });

    update();
  }

  function initAll() { document.querySelectorAll('[data-sg]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target;
    var track = slide && slide.closest && slide.closest('[data-sg-track]');
    if (track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  });
})();